import ColorPicker from 'components/editor/shared/components/ColorPicker';
import Grid from '@mui/material/Grid';
import { SecondaryMenuItemTitle } from './SecondaryMenuTitles';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { getDocumentColors } from 'components/editor/grid/reduxStore/selectors/documentColorsSelector';
import type { colorParams } from 'components/editor/shared/components/ColorPicker/types';

type ColorPickerSectionProps = {
  currentColor?: string;
  onColorChange: (color: string) => void;
  onClose?: (color: string) => void;
  title?: string;
  onOpen?: () => void;
};

export const ColorPickerSection = ({ currentColor = '#fff', onColorChange, title, onClose, onOpen }: ColorPickerSectionProps) => {
  const { t } = useTranslation();
  const colorPickerTitle = title || t('editor.side_panel.color');
  const [documentColors, setDocumentColors] = useState<colorParams[] | undefined>(undefined);

  const handleOpen = () => {
    setDocumentColors(getDocumentColors());
    onOpen?.();
  };

  return (
    <Grid container alignItems="center" justifyContent="space-between">
      <SecondaryMenuItemTitle>{colorPickerTitle}</SecondaryMenuItemTitle>
      <Grid item>
        <ColorPicker
          currentColor={currentColor}
          handleColorChange={onColorChange}
          handleOnClose={onClose}
          onOpen={handleOpen}
          presetColors={documentColors}
        />
      </Grid>
    </Grid>
  );
};
